import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class AdditionalInvestmentService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/additionalInvestment`;
  }

  getAdditionalInvestmentList(): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getAdditionalInvestments`;
    return this.http.get(REST_URL);
  }

  getComplianceOfficerAdditionalInvestments(username: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getComplianceOfficerAdditionalInvestments`;
    return this.http.get(`${REST_URL}?username=${username}`);
  }

  getComplianceOfficerAdditionalInvestmentsHistory(username: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getComplianceOfficerAdditionalInvestmentsHistory`;
    return this.http.get(`${REST_URL}?username=${username}`);
  }

  approvePendingAdditionalInvestment(documentId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/approvePendingAdditionalInvestment`;
    return this.http.post(REST_URL, {documentId});
  }

  declinePendingAdditionalInvestment(documentId: string, feedback: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/declinePendingAdditionalInvestment`;
    return this.http.post(REST_URL, {documentId, feedback});
  }

  sendDeclinedEmailAdditionalInvestment(email: string, feedback: string, contractNumber: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/sendDeclinedEmailAdditionalInvestment`;
    return this.http.post(REST_URL, {email, feedback, contractNumber});
  }

  sendApprovedEmailAdditionalInvestment(email: string, contractNumber: string, submissionProcess: string, signatories: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/sendApprovedEmailAdditionalInvestment`;
    return this.http.post(REST_URL, {email, contractNumber, submissionProcess, signatories});
  }

  getAdditionalInvestmentDetailPDF(instructionId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getAdditionalInvestmentDetailPDF`;
    return this.http.get(`${REST_URL}?additionalInvestmentId=${instructionId}`, {responseType: 'blob'});
  }
}
